import './card.css';
import React from 'react';
import PropTypes from 'prop-types';
import focusSetting from './../Focus/settings';
import CardHelper from './helpers';
import CardHelperNew from '../CardNew/helpers'
import CoverImage from "../CoverImage";
import ActivesSingleton from "../../components/Header/ActivesSingleton";
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import Asset from "../../requests/apa/Asset";
import getAppConfig from '../../config/appConfig';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import store from '../../store';
import { playFullMedia, playPipMedia } from '../../actions/playmedia';
import FakeLink from '../../components/FakeLink';
import AAFPlayer from "../../AAFPlayer/AAFPlayer";
import SearchFlag from '../../containers/Search/SearchFlag';
import { LIVE_PLAY_FROM_HOME } from '../../AAFPlayer/helpers/ThirdPartyEpgHelper';
import EpisodeInfo from './EpisodeInfo';
import { cls } from '../../packages/components';
import {getContentAvailability} from '../../utils/Utils';
import {GA4} from 'src/utils/trackers/GA4';
import {CONTENT_TYPE_MOVIE, CONTENT_TYPE_SERIE, CONTENT_TYPE_TV, CONTENT_SECTION_SEARCH} from 'src/utils/trackers/GA4Constants';
import PlayerStreamingUtils from 'src/utils/PlayerStreamingUtils';
import asyncPinObserver from 'src/AAF/Pin/AsyncPinObserver';
import Utils from '../../utils/Utils';
import {applyOutLineFocus} from "../Focus/utils";
import Device from "../../devices/device";
import { sendMetricSelectContentHBO } from '../CardNew/utils';
import { UNLINKED, PENDING, HBO_SUBSCRIPTION, HBO_ACTIVATION_MODAL_DELAY_MS } from '../RibbonNew/constants';
import { getStatusHBOCard } from '../CardNew/utils.js';
import { showModal } from 'src/actions/modal';
import { AAF_MODAL_INICIAL_ACTIVA_HBO_MAX } from 'src/actions/modal';
import logger from 'src/utils/logger/logger';

function createMarkup(markup) {
  return { __html: markup };
}

function ImageTalent(props) {
  const { coverTalents, classOutLineFocus, cardImgClassName, handleError, title, isTalentSearch } = props;
  const platform = Device.getDevice().getPlatform()
  return (
    platform === "ps4" && isTalentSearch
      ? <img
        className={`${cardImgClassName} ${classOutLineFocus}`}
        onError={handleError}
        style={{ boxSizing: "border-box", objectFit: 'cover' }}
        src={`${coverTalents}?size&imwidth=268`}
        alt={title}
      />
      : <div
        className={`${cardImgClassName} ${classOutLineFocus}`}
        onError={handleError}
        style={{backgroundImage: `url(${coverTalents}?size&imwidth=268)` }}
      />
  )
}

function Card(props) {
  const focusClassName = props.focusable ? focusSetting.className : focusSetting.nonfocusable;
  const focusClass = CardHelper.getFocusClass(focusClassName, props);
  const classOutLineFocus = applyOutLineFocus();
  const cardImgClassName = props.data.music_class ? `${props.data.music_class} card-cover ${classOutLineFocus}` : 'card-cover';
  const is_music_cover = props.is_music || props.data.music_class;
  const props_data = props.data;
  const handleError = (event) => {
    if (props.data.groupName) {
      const typeOfError = props.data.groupName.toLowerCase();
      event.target.src = CardHelper.getPlaceholder(typeOfError);
    }
    else event.target.src = CardHelper.getPlaceholder(props.type);
  }

  let placeholder = CardHelper.getPlaceholder(props.type);
  if (props.data.groupName) {
    const type = props.data.groupName.toLowerCase();
    placeholder = CardHelper.getPlaceholder(type);
  }

  function sendDimension() {
    const payload = new AnalyticsDimensionSingleton().getPayload();
    props.setMetricsEvent(payload);
    props.setMetricsEvent({ type: 'executor' });
  }


  function sendMetric() {
    let label = '';
    const location = window.location.toString();
    const url = location.split('/');
    let action = url[url.length - 1];
    const props_data = props.data;
    const props_dataMetric = props.dataMetric;
    switch (props.type) {
      case 'highlight':
        if (location.indexOf('claromusica') !== -1) {
          let title = props.title === '' ? ' superdestacado' : props.title;
          let carruselTitle = props_dataMetric.carruselTitle === '' ? 'superdestacado' : props.title;
          action = `${new ActivesSingleton().getTree()}/${carruselTitle}`;
          label = `${props_dataMetric.cardPosition} | ${title}`;
        }
        else {
          const props_data_format_type = props_data.format_types;
          if (props_data_format_type !== null) {
            if (typeof props_data_format_type === 'string') {
              label = `${props_data_format_type} - `;
            }
            else {//if(typeof props_data_format_type === 'Array') {
              label = `${props_data_format_type.reduce(
                (previous, current) => previous + ',' + current
              )} - `;
            }
          }
          const carruselTitle = props_dataMetric.carruselTitle !== null
            ? props_dataMetric.carruselTitle
            : 'superdestacado';
          label += `${props.title} - ${props_dataMetric.cardPosition} | ${carruselTitle}`;
          action = new ActivesSingleton().getTree();
        }
        props.setMetricsEvent({
          hitType: 'event',
          eventCategory: 'carrusel',
          eventAction: action,
          eventLabel: label,
        });
        break;
      case 'landscape':
        if (location.indexOf('claromusica') !== -1) {
          action = `${new ActivesSingleton().getTree()}/${props_dataMetric.carruselTitle}`;
          label = `${props_dataMetric.cardPosition} | ${props.title}`;
        }
        else {
          const props_data_format_type = props_data.format_types;
          if (typeof props_data_format_type !== 'undefined') {
            if (typeof props_data_format_type === 'string') {
              label = `${props_data_format_type} - `;
            }
            else if (typeof props_data_format_type === 'Array') {
              label = `${props_data_format_type.reduce((previous, current) => previous + ',' + current)} - `;
            }
          }
          if (location.indexOf('talent') !== -1 || location.indexOf('vcard') !== -1) {
            action = 'vcard';
            label += `-${props.title} - ${props_dataMetric.cardPosition} | ${props_dataMetric.carruselTitle}`;
          }
          else if (location.indexOf('socialProfile') !== -1) {
            action = 'perfil';
            let title = props.data.title_uri.replace(/-/g, ' ');
            label += `-${title} - ${props_dataMetric.cardPosition} | ${props_dataMetric.carruselTitle}`;
          }
          else {
            action = new ActivesSingleton().getTree();
            label += `${props.title} - ${props_dataMetric.cardPosition} | ${props_dataMetric.carruselTitle}`;
          }
        }
        props.setMetricsEvent({
          hitType: 'event',
          eventCategory: 'carrusel',
          eventAction: action,
          eventLabel: label,
        });
        break;
      case 'infinite':
        label = `${props_data.format_types}-${props_data.title} - ${props_dataMetric.cardPosition} | Listado Infinito`;
        action = new ActivesSingleton().getTree();
        props.setMetricsEvent({
          hitType: 'event',
          eventCategory: 'carrusel',
          eventAction: action,
          eventLabel: label,
        });
        break;
      case 'user-profile':
      case 'user-info':
        if (location.indexOf('vcard') !== -1)
          action = 'vcard';
        label = `${props.title} - ${props_dataMetric.cardPosition} | ${props_dataMetric.carruselTitle}`;
        props.setMetricsEvent({
          hitType: 'event',
          eventCategory: 'carrusel',
          eventAction: action,
          eventLabel: label,
        });
        break;
      case 'channel':
        label = props_data.title;
        props.setMetricsEvent({
          hitType: 'event',
          eventCategory: 'tv',
          eventAction: 'menu canales',
          eventLabel: label,
        });
        break;
      case 'portrait':
        action = new ActivesSingleton().getTree();
        label = `${props.title} - ${props_dataMetric.cardPosition} | ${props_dataMetric.carruselTitle}`;
        props.setMetricsEvent({
          hitType: 'event',
          eventCategory: 'carrusel',
          eventAction: action,
          eventLabel: label,
        });
        break;

      case 'square':
        if (location.indexOf('claromusica') !== -1) {
          if (typeof props_data !== 'undefined') {
            if (props_data.type === 'radio') {
              if (props.stationTitle === 'genero') {
                label = `${props_data.genre} - ${props_data.name}`;
                props.setMetricsEvent({
                  hitType: 'event',
                  eventCategory: 'radios',
                  eventAction: 'genero',
                  eventLabel: label,
                });
              }
              else {
                label = `${props.stationTitle} - ${props_data.name}`;
                props.setMetricsEvent({
                  hitType: 'event',
                  eventCategory: 'radios',
                  eventAction: 'estaciones',
                  eventLabel: label,
                });
              }
            }
            else if (props_data.type === 'Playlist' || props_data.type === 'radios' || props_data.type === 'Radio') {
              action = `${new ActivesSingleton().getTree()}/${props_dataMetric.carruselTitle}`;
              label = `${props_dataMetric.cardPosition} | ${props.title}`;
              props.setMetricsEvent({
                hitType: 'event',
                eventCategory: 'carrusel',
                eventAction: action,
                eventLabel: label,
              });
            }
          }
        }
        break;
      case 'circle':
        if (location.indexOf('claromusica') !== -1) {
          if (props.stationTitle === 'artistas') {
            props.setMetricsEvent({
              hitType: 'event',
              eventCategory: 'radios',
              eventAction: 'artistas',
              eventLabel: props_data.artist,
            });
          } else {
            action = `${new ActivesSingleton().getTree()}/${props_dataMetric.carruselTitle}`;
            label = `${props_dataMetric.cardPosition} | ${props.title}`;
            props.setMetricsEvent({
              hitType: 'event',
              eventCategory: 'carrusel',
              eventAction: action,
              eventLabel: label,
            });
          }
        }

        break;
      case 'epg_event':
        logger.debug('[HOMOLOGACION] epg_event ...');

        const props_data_format_type = props_data.format_types;

        if (typeof props_data_format_type !== 'undefined') {
          if (typeof props_data_format_type === 'string') {
            label = `${props_data_format_type} - `;
          }
          else if (typeof props_data_format_type === 'Array') {
            label = `${props_data_format_type.reduce((previous, current) => previous + ',' + current)} - `;
          }
        }
        if (location.indexOf('talent') !== -1 || location.indexOf('vcard') !== -1) {
          action = 'vcard';
          label += `-${props.title} - ${props_dataMetric.cardPosition} | ${props_dataMetric.carruselTitle}`;
        }
        else if (location.indexOf('socialProfile') !== -1) {
          action = 'perfil';
          let title = props.data.title_uri.replace(/-/g, ' ');
          label += `-${title} - ${props_dataMetric.cardPosition} | ${props_dataMetric.carruselTitle}`;
        }
        else {
          action = new ActivesSingleton().getTree();
          label += `${props.title} - ${props_dataMetric.cardPosition} | ${props_dataMetric.carruselTitle}`;
        }

        props.setMetricsEvent({
          hitType: 'event',
          eventCategory: 'carrusel',
          eventAction: action,
          eventLabel: label,
        });
        break;
      default:
        break;
    }
    props.setMetricsEvent({ type: 'executor' });
    sendDimension();
  }

  function sendGA4Metric(){
    const {data, data: {id, format_types, provider}, title, ribbonName, dataMetric: {carruselTitle} = {}} = props;
    const gA4 = new GA4();
    const content_id = id;
    const content_section = getContentSection();
    const content_list = ribbonName || carruselTitle || '';
    const content_name = title;
    const content_type = getContentType(data);
    const content_category = '';
    const content_availability = getContentAvailability(format_types, provider);
    gA4.sendSelectContentEvent(content_section, content_list, content_id, content_name, content_type, content_category, content_availability)
  }

  function isHBOv2Provider(data) {
    return Boolean(data) && data.provider === 'hbov2';
  }

  function hasHBOSubscription(user) {
    return Array.isArray(user.superhighlight) && user.superhighlight.includes(HBO_SUBSCRIPTION);
  }

  async function resolveHBOActivationStatus(user) {
    let statusHBO = user.statusHBO;
    let showActivationModalHBO = user.showActivationModalHBO;

    const hboStatus = await getStatusHBOCard();
    if (hboStatus && typeof hboStatus.showActivationModalHBO === 'boolean') {
      statusHBO = hboStatus.statusHBO;
      showActivationModalHBO = hboStatus.showActivationModalHBO;
    }
    return { statusHBO, showActivationModalHBO };
  }

  function shouldShowHBOActivationModal({ statusHBO, showActivationModalHBO }) {
    return showActivationModalHBO && (statusHBO === UNLINKED || statusHBO === PENDING);
  }

  function isHBOLiveref(data) {
    return Boolean(data) && typeof data.channel_liveref === 'string' && data.channel_liveref.toLowerCase().includes('hbo');
  }

  async function checkModalHBO() {
    const { data } = props;
    const { user = {} } = store.getState() || {};

    const isProviderHBOv2 = isHBOv2Provider(data);
    const isLiverefHBO = isHBOLiveref(data);
    const isProfileAdmin = Boolean(user.admin);
    const eventAlfId = data && data.event_alf_id ? data.event_alf_id : null;
    const isCurrentEvent = Utils.isDateBetween(data && data.unix_begin, data && data.unix_end);
    const isHBOvCard = isProviderHBOv2 || (eventAlfId && isLiverefHBO && !isCurrentEvent);

    if (!isHBOvCard || !hasHBOSubscription(user) || !isProfileAdmin) {
      return;
    }

    const activationStatus = await resolveHBOActivationStatus(user);
    if (!shouldShowHBOActivationModal(activationStatus)) {
      return;
    }

    if (isHBOvCard) {
      sendMetricSelectContentHBO(data);
      const modal = {
          modalType: AAF_MODAL_INICIAL_ACTIVA_HBO_MAX,
          modalProps: {
            data
          }
      };
      setTimeout(() => {
          store.dispatch(showModal(modal));
      }, HBO_ACTIVATION_MODAL_DELAY_MS);
      return;
    }
  }

function getContentSection(){
  const { navbar:{from: {node_initial } = {}} = {} } = store.getState() || {};
  const BUSQUEDA = 'busqueda';
  if (node_initial === BUSQUEDA) {
    return CONTENT_SECTION_SEARCH;
  }else {
    return '';
  }

}

function getContentType(data){
  const {type, is_series} = data;
  if (type === "live") return CONTENT_TYPE_TV;
  if (is_series) return CONTENT_TYPE_SERIE;
  return CONTENT_TYPE_MOVIE;
}

  let linkTo;
  if (props_data && props_data.ads === 'app_behaviour') linkTo = props_data.href;
  else linkTo = CardHelper.getUri(props.href, props.group_id, props_data, props.ignoreSeenLast);

  let cover = props.cover;
  let config = getAppConfig();
  if (props_data.type === 'Radio' || props_data.type === 'radio') {
    cover = config.end_point_music + '/middleware/cms/proxyImage?url=' + cover.replace("https:", "http:") + "&size=400&imwidth=165";
  } else if (is_music_cover) {
    cover = Utils.adaptImageProtocol(cover);
  }
  let isGoingToPlay = false;
  let isGoingToPlayWithFilter = !!props.filterTV;
  linkTo = linkTo.indexOf('/') > 0 ? `/${linkTo}` : linkTo;
  if (linkTo.indexOf('/player/') !== -1) {
    linkTo = '';
    isGoingToPlay = true;
    if (props.filterTV) {
      isGoingToPlayWithFilter = true;
      isGoingToPlay = false;
    }
  }

  const coverTalents = props.cover !== null ? props.cover : CardHelper.getPlaceholder(props.type);
  const title = props.title || "";
  let {auxRibbonId, idPs} = CardHelper.getIdsForCardDynamicFocus(is_music_cover, props.ribbonId, props.titleRibbon, props.id, props.group_id, title);

  function getDataSnUpAndDown() {

    return {
      focusUp: CardHelperNew.getDataSnUpAndDown(
        props.idsRibbonsUpAndDown,
        props.ribbonIndex,
        props.focusUp,
        props.focusDown).focusUp,
      focusDown: CardHelperNew.getDataSnUpAndDown(
        props.idsRibbonsUpAndDown,
        props.ribbonIndex,
        props.focusUp,
        props.focusDown).focusDown
    };
  }

  const handleMouseEnter = (e) => {
    Utils.handleMouseEnter(e)
  }

  const isTalentSearch = idPs.includes("buscadortalentos") ? "buscadortalentos" : ""

  return (
    <div id={props.id}
      className={`card ${props.type} ${props.className} ${props.sibling ? 'double' : ''}`}
      ref={props.onLoadHandler}>
      {CardHelper.createSibling(props.sibling)}
      <div className="card-container">
        <FakeLink
          typeRender={props.typeRender}
          id={idPs}
          to={linkTo}
          className={cls("link", focusClass, `focus_${auxRibbonId}_${props.id}`, {"fakelink-episode": props.extraInfo}, `${isTalentSearch}`)}
          data-counter={props.positionInfinite}
          data-sn-up={getDataSnUpAndDown().focusUp}
          data-sn-down={getDataSnUpAndDown().focusDown}
          data-sn-right={props.focusRight}
          data-sn-left={props.focusLeft}
          onClick={async (e) => {
            if (props.dataUpdateMetrics) {
              props.dataUpdateMetrics();
            }
            logger.debug("[Card] linkTo", linkTo);
            if (typeof props.setMetricsEvent === 'function') {
              try {
                sendMetric();
                sendGA4Metric();
                checkModalHBO();
              } catch (e) {
                logger.error('Could not send metrics from card click', e);
              }
            }
            if (typeof props.clickHandler !== 'function'
              && !isGoingToPlay && !isGoingToPlayWithFilter) {
              return null;
            }
            if (typeof props.onClickCb === 'function') {
              if (props.data && props.data.live_enabled == "0") { //si el link es a vcard no se tiene que ejecutar la funcion
                return null;
              } else {
                props.onClickCb(e); //Esta funcion se ocupa para la grilla de canales
              }
            }

            e.preventDefault();

            const { isRecord = false } = props.data;
            const { event_id = null } = props.data;
            const { live_enabled = '0'} = props.data;
            const { type = null} = props.data;
            const playerStreamingUtils = new PlayerStreamingUtils();

            const dispatchPlayMedia = (group_id, filterTV) => {
              store.dispatch(playFullMedia({
                playerstate: 'PLAYING',
                source: {
                  videoid: group_id
                },
                ispreview: false,
                islive: true,
                size: {
                  top: 0,
                  left: 0,
                  width: 792,
                  height: 428,
                },
                ispip: false,
                showEpg: false,
                filterTV: filterTV,
                event: null,
                playFromCard: true,
                /**
                 * Considerar reemplazar la bandera de arriba con la bandera de abajo (quitar playFromCard y dejar playLiveFrom)
                 */
                playLiveFrom: LIVE_PLAY_FROM_HOME,
                npvrEvent: (isRecord && event_id ? props.data : null)
              }));
            };

            if (is_music_cover && typeof props.clickHandler === 'function') {
              return props.clickHandler(props_data);
            } else if ((live_enabled === '1' || type ==='live') && !playerStreamingUtils.canPlayChannel(props.group_id)) {
              asyncPinObserver.fire('awaitpbiInfo');
              playerStreamingUtils.checkSusc(null, props.group_id, () => { }, props.data).then(() => {
                asyncPinObserver.fire('pbiInfocomplete');
              });
            } else if (isGoingToPlay) {
              dispatchPlayMedia(props.group_id);
              SearchFlag.setFlag(true);
              return null;
            } else if (isGoingToPlayWithFilter) {
              let filterGroupid = null;
              new ChannelSingleton().getFilteredChannels(props.group_id)
                .then(async (availableChannels) => {
                  if (availableChannels.length === 0) {
                    availableChannels.push({ groupId: props.group_id });
                  }
                  filterGroupid = availableChannels[0].group_id;
                  const currentPlayerOptions = AAFPlayer.getCurrentPlayerOptions();
                  if (currentPlayerOptions.playerstate === 'PLAYING' && currentPlayerOptions.islive && !currentPlayerOptions.hasOwnProperty('audiosource') && currentPlayerOptions.size.width < 1280) {
                    filterGroupid = currentPlayerOptions.source && currentPlayerOptions.source.videoid ? currentPlayerOptions.source.videoid : filterGroupid;
                  }
                  filterGroupid && dispatchPlayMedia(filterGroupid, props.filterTV);
                });
              return null;
            } else {
              return props.clickHandler();
            }

          }}
          onFocus={() => {
            CardHelper.focusHandler(props.focusHandler, props_data)
            if (props_data.episode) {
              //TODO:Si se desea que al seleccionar el episodio se actualice la ficha, va esta linea.
              //store.dispatch(setResumeData(props_data));
            }
          }}
          onKeyUp={() => CardHelper.keyUpHandler(props.keyUpHandler, props)}
          onKeyDown={e => CardHelper.keyDownHandler(e, props.keyDownHandler, props.data)}
          onBlur={props.unFocusHandler}
          onMouseEnter={() => handleMouseEnter(idPs)}
        >
          {is_music_cover ?
            <CoverImage
              contentProps={props_data}
              image={cover}
              imagePlaceholder={CardHelper.getPlaceholder(props.type)}
              type={props.type}
              classComponent={cardImgClassName}
            /> : props.type === 'text' ? null :
          <div className={cls('card card-view',{"card-episode":props.extraInfo})}>
            <div className="card-container">
              <div className={`preview-container`}>
                {props.cover !== '' &&
                  <ImageTalent
                    cardImgClassName={cardImgClassName}
                    classOutLineFocus={classOutLineFocus}
                    handleError={handleError}
                    coverTalents={coverTalents}
                    title={props.data.name}
                    isTalentSearch={isTalentSearch}
                  />
                }
                {CardHelperNew.createProgressBar(props.bookmark)}
                {
                  props.type === 'text' ?
                    <div className={`text`}> {props.data.name} </div> :
                    <div className='cn-box-badge-styles' dangerouslySetInnerHTML={createMarkup(props.badgesHtml)} />
                }
              </div>
            </div>
          </div>
          }
          {
            (
              (props_data.provider !== 'default'
                && props_data.proveedor_code !== 'amco'
              )
              && !props.hideInnerTitle
            ) &&
            <div className={`card-metadata ${props.data.isRecord ? 'recording' : ''} ${props.data.isSeries ? 'is-series' : ''} ${props.data.isRecording ? 'is-recording' : ''}`}>
              {
                CardHelper.posterTitleIsEnabled(props.data.provider, props.type) ? (
                  <div className="inner-title">
                    {(props.filterTV ? ' ' : props.title)}
                    {
                      typeof props.data.dateOfEvent === 'string'
                        ? <div style={{ color: '#aaa', fontSize: 14 }}>{props.data.dateOfEvent}</div>
                        : null
                    }
                  </div>
                ) : ''
              }
              {
                props.data.isSeries ?
                  <div style={{
                    position: 'absolute',
                    right: 16,
                    bottom: 10,
                    color: '#fff',
                    zIndex: 1,
                  }}>
                    <img
                      style={{ width: 35 }}
                      className="icon icon-record recording"
                      src={Asset.get("player_controls_seasons_icon")}
                      alt="recording icon"
                    />
                  </div>
                  : null
              }
              {
                props.data.isRecording && !props.data.isSeries ?
                  <div style={{
                    position: 'absolute',
                    right: 16,
                    bottom: 10,
                    color: '#fff',
                    zIndex: 1,
                  }}>
                    <img
                      style={{ width: 35 }}
                      className="icon icon-record recording"
                      src={Asset.get("player_controls_recording_icon")}
                      alt="recording icon"
                    />
                  </div>
                  : null
              }
            </div>
          }
          {
            props.extraInfo && <EpisodeInfo title={props.extraInfo.title_episode} episodeNumber={props.extraInfo.episode_number} description={props.extraInfo.description}/>
          }
        </FakeLink>
        { (props.modalSeasons) ?
          <div className="card-labels-container">
          { props.type !== 'square' ? CardHelper.createTitle(props.title, props.isTalent, props.data && props.data.groupName) : !is_music_cover ? CardHelper.createTitle(props.title) : ''}
          {CardHelper.createLabel(props.label)}
          </div>: null
        }
      </div>
      {
        !props.hideTitles ? (
          <div className="card-labels-container">
            { props.type !== 'square' ? CardHelper.createTitle(props.title, props.isTalent, props.data && props.data.groupName) : !is_music_cover ? CardHelper.createTitle(props.title) : ''}
            {CardHelper.createLabel(props.label)}
          </div>
        ) : ''
      }
    </div>
  );
}

const cardTypes = ['portrait', 'landscape', 'highlight', 'user-profile', 'user-info', 'cd', 'channel', 'infinite', 'square', 'talent', 'epg_event', 'text', 'circle'];
Card.propTypes = {
  className: PropTypes.string,
  hideTitles: PropTypes.bool,
  group_id: PropTypes.string,
  data: PropTypes.object,
  cover: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  title: PropTypes.string,
  label: PropTypes.string,
  href: PropTypes.string,
  bookmark: PropTypes.string,
  type: PropTypes.oneOf(cardTypes),
  focusable: PropTypes.bool,
  focusUp: PropTypes.string,
  focusRight: PropTypes.string,
  focusLeft: PropTypes.string,
  sibling: PropTypes.string,

  filterTV: PropTypes.string,

  badgesAlign: PropTypes.oneOf(['left', 'right']),
  badges: PropTypes.arrayOf(PropTypes.object),
  badgesHtml: PropTypes.string,

  unFocusHandler: PropTypes.func,
  clickHandler: PropTypes.func,
  onClickCb: PropTypes.func,
  focusHandler: PropTypes.func,
  setMetricsEvent: PropTypes.func,
  keyUpHandler: PropTypes.func,
  keyDownHandler: PropTypes.func,
  onLoadHandler: PropTypes.func,

  typeRender: PropTypes.string,
  isTalent: PropTypes.bool,
};

Card.defaultProps = {
  id: null,
  className: '',
  hideTitles: false,
  group_id: '',
  data: {},
  cover: '',
  title: '',
  label: '',
  href: null,
  bookmark: 0,
  type: 'landscape',
  focusable: true,
  focusUp: null,
  focusRight: null,
  focusLeft: null,
  sibling: null,

  filterTV: '',

  badgesAlign: 'right',
  badges: [],
  badgesHtml: '',

  unFocusHandler: null,
  clickHandler: null,
  focusHandler: null,
  setMetricsEvent: null,
  keyUpHandler: null,
  keyDownHandler: null,
  onLoadHandler: null,
  onClickCb: null,

  typeRender: null,
  isTalent: false,
};

export default Card;

export { cardTypes };



// WEBPACK FOOTER //
// ./src/components/Card/index.jsx